module.exports = __webpack_public_path__ + "static/media/1.fe939c8c.jpg";